(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-model-guide"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('tp-size-drop'))return;customElements.define('tp-size-drop',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const select=this.querySelector('[data-size]');const cards=[...this.querySelectorAll('[data-product]')].map(el=>{let variants=[];try{variants=JSON.parse(el.querySelector('[data-variants]').textContent);}catch(e){}return {el,variants};});const sizes=[...new Set(cards.flatMap(c=>c.variants.map(v=>v.size)))].filter(Boolean).sort((a,b)=>String(a).localeCompare(String(b),'sr',{numeric:true}));if(!sizes.length)return;select.replaceChildren(new Option('Svi dostupni brojevi',''),...sizes.map(size=>new Option(size,size)));this.querySelector('[data-controls]').hidden=false;const render=()=>{let count=0;cards.forEach(({el,variants})=>{const variant=select.value?variants.find(v=>v.size===select.value):variants[0];el.hidden=!variant;if(!variant)return;count++;el.querySelectorAll('[data-link]').forEach(a=>a.setAttribute('href',variant.url));el.querySelector('[data-price]').textContent=variant.price;el.querySelector('[data-label]').textContent=select.value?'Izaberi broj '+select.value:'Pogledaj brojeve';});this.querySelector('[data-status]').textContent=select.value?'Dostupnih modela u broju '+select.value+': '+count:'Dostupnih modela: '+count;this.querySelector('[data-empty]').hidden=count!==0;};select.addEventListener('change',render,{signal:this.abort.signal});render();}
disconnectedCallback(){this.abort?.abort();this.abort=null;}
});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-trust"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('.tpts:not([data-initialized])').forEach(el=>{el.dataset.initialized='true';if(!('IntersectionObserver' in window))return;const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){el.classList.add('is-seen');observer.disconnect();}},{threshold:.15});observer.observe(el);});};init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendypatike-trust-help"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(window.__tpTrustFaqRouterV2)return;window.__tpTrustFaqRouterV2=true;
  const normalize=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim().toLowerCase();
  const titles={dostava:['Da li nudite besplatnu dostavu?'],zamena:['Šta ako dobijem pogrešan proizvod ili proizvod sa greškom?'],placanje:['Plaćanje']};
  let last='';
  function openRequested(){
    let key;try{key=decodeURIComponent(location.hash).replace(/^#tp-help-/,'');}catch(_){key='';}
    if(!titles[key])key=new URL(location.href).searchParams.get('tp_faq');if(!titles[key])return;
    const expected=titles[key].map(normalize);
    const controls=[...document.querySelectorAll('summary,[data-tpfaq-toggle]')];
    const control=controls.find(el=>expected.includes(normalize(el.querySelector('span')?.textContent||el.textContent)));if(!control)return;
    const signature=location.href+'|'+key;if(last===signature&&((control.closest('details')?.open)||control.getAttribute('aria-expanded')==='true'))return;
    const details=control.closest('details');let target=details||control.closest('.tpfaq-item')||control;
    if(details)details.open=true;
    else{if(control.getAttribute('aria-expanded')!=='true')control.click();target.classList.add('is-open');control.setAttribute('aria-expanded','true');}
    target.id='tp-help-'+key;target.style.scrollMarginTop='120px';last=signature;
    requestAnimationFrame(()=>{target.scrollIntoView({block:'start',behavior:'auto'});control.focus({preventScroll:true});});
  }
  document.addEventListener('DOMContentLoaded',openRequested);window.addEventListener('load',openRequested);window.addEventListener('pageshow',openRequested);window.addEventListener('hashchange',openRequested);window.addEventListener('popstate',openRequested);document.addEventListener('shopify:section:load',openRequested);
  if(document.readyState!=='loading')openRequested();
})();


  } catch(e) { console.error(e); }
})();
})();
